import React from "react";
import L from "leaflet";
import { Marker, Popup } from "react-leaflet";

import { carsStatuses } from "./../../components/sections/cars/static.carsStatuses";
import { getMarker } from "./getMarker";

import "./mapMarker.scss";

const getMarkerState = function (status) {
  var markerStatus;

  Object.values(carsStatuses).map((item) => {
    if (status === item.id) {
      markerStatus = item.name;
    }
    return null;
  });

  return markerStatus;
};

const MapMarker = (props) => {
  const { position, status, number, onClick = () => {} } = props;
  const markerIcon = L.divIcon({
    iconSize: [53, 63],
    iconAnchor: [28, 52],
    popupAnchor: [0, -63],
    className: "mapMarker " + getMarkerState(status),
    html: getMarker("inner", number),
  });

  return (
    <Marker
      position={position}
      icon={markerIcon}
      eventHandlers={{
        click: onClick,
      }}
    >
      {props.children}
      <Popup className="mapPopup" />
    </Marker>
  );
};

export default React.memo(MapMarker);
